// extracted by mini-css-extract-plugin
export var drawerContent = "_38-0";
export var valueBlock = "_38-1";
export var valueBlockFrom = "_38-2 _38-1";
export var valueBlockTo = "_38-3 _38-1";